const _ModuleToast = new ModuleToast();
const axiosBaseUrl = $('meta[name="baseUrl"]').attr('content');
axios.defaults.baseURL = axiosBaseUrl;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// common ไม่ใช่ post — GET ที่ไม่มี header นี้จะไม่ถูก session_write_close()
// ทำให้ทุก request ของ user คนเดียวกันต่อคิว flock() ทีละอัน
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Add a request interceptor
axios.interceptors.request.use(
    function (config) {
        $('.is-invalid').removeClass('is-invalid');
        $('.invalid-feedback').remove();

        // Do something before request is sent
        const { method, params, data } = config;
        if (method === 'get' && params) {
            config.params = {
                ...config.params, // คัดลอก params เดิม
                csrf_hash_name: $('meta[name="csrf-token"]').attr('content'), // เพิ่ม params ใหม่
            };
        } else if (method === 'post' && data) {
            if (data instanceof FormData) {
                config.data.append('csrf_hash_name', $('meta[name="csrf-token"]').attr('content'));
            } else if (data instanceof URLSearchParams) {
                // รองรับ URLSearchParams
                config.data.append('csrf_hash_name', $('meta[name="csrf-token"]').attr('content'));
            } else if (typeof data === 'object') {
                config.data.csrf_hash_name = $('meta[name="csrf-token"]').attr('content');
            }
        }

        return config;
    },
    function (error) {
        // ปิด loading
        Swal.close();
        // Do something with request error
        return Promise.reject(error);
    },
);

// Add a response interceptor
axios.interceptors.response.use(
    function (response) {
        Swal.close();
        if (response.data.csrf_token) {
            $('meta[name="csrf-token"]').attr('content', response.data.csrf_token);
        }
        // ปิด loading
        // Do something with response data
        return response;
    },
    function (error) {
        // ปิด loading
        Swal.close();

        if (error.response) {
            // อัพเดท csrf token ถ้ามี
            if (error.response.data.csrf_token) {
                $('meta[name="csrf-token"]').attr('content', error.response.data.csrf_token);
            }

            // จัดการ validation error (422)
            if (error.response.status === 422) {
                _ModuleToast.warning(error.response.data.message || 'กรุณาตรวจสอบข้อมูลอีกครั้ง');
                let inputErrors = error.response.data.errors;
                for (let key in inputErrors) {
                    if ($(`.validate-input[name="${key}"]`).length > 0) {
                        // กรณีเป็น input-group
                        if ($(`.validate-input[name="${key}"]`).parent().hasClass('input-group')) {
                            $(`<span class="invalid-feedback d-block">${inputErrors[key]}</span>`).insertAfter(
                                $(`.validate-input[name="${key}"]`).parent(),
                            );
                        } else {
                            $(`<span class="invalid-feedback">${inputErrors[key]}</span>`).insertAfter(
                                `.validate-input[name="${key}"]`,
                            );
                        }
                        $(`.validate-input[name="${key}"]`).addClass('is-invalid');
                    } else {
                        let input = document.getElementById(key);
                        input = $(input);
                        $(`<span class="invalid-feedback">${inputErrors[key]}</span>`).insertAfter(input);
                        input.addClass('is-invalid');
                    }
                }
            }
            // แสดง error message ตาม status code
            else if (error.response.status === 401 && error.response.data.connect_url) {
                Swal.fire({
                    icon: 'warning',
                    text: error.response.data.message,
                    showCloseButton: true,
                    confirmButtonText: error.response.data.connect_label,
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.href = error.response.data.connect_url;
                    }
                });
            } else if (error.response.status === 401) {
                _ModuleToast.error(error.response.data.message || 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง');
            } else if (error.response.status === 403) {
                _ModuleToast.error(error.response.data.message || 'คุณไม่มีสิทธิ์ในการดำเนินการนี้');
            } else if (error.response.status === 404) {
                _ModuleToast.error(error.response.data.message || 'ไม่พบข้อมูลที่ร้องขอ');
            } else if (error.response.status >= 500) {
                _ModuleToast.error(error.response.data.message || 'เกิดข้อผิดพลาดที่เซิร์ฟเวอร์ กรุณาลองใหม่อีกครั้ง');
            }
        } else if (error.request) {
            _ModuleToast.error(
                error.response.data.message ||
                    'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้ กรุณาตรวจสอบการเชื่อมต่ออินเทอร์เน็ต',
            );
        } else {
            _ModuleToast.error(error.message || 'เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ กรุณาลองใหม่อีกครั้ง');
        }

        return Promise.reject(error);
    },
);
